import React, { useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, BookOpen, X } from 'lucide-react';
import { SectionTitle } from '../ui/SectionTitle';
const tomos = [{
  id: 1,
  title: 'Fundamentos del Tarot Rider-Waite',
  description: 'Descubrí los principios esenciales del Tarot Rider-Waite, su historia, estructura y simbología. Aprendé las bases necesarias para comenzar a interpretar las cartas con confianza.'
}, {
  id: 2,
  title: 'Los 22 Arcanos Mayores',
  description: 'Conocé en profundidad el significado, simbolismo y enseñanza de cada Arcano Mayor. Comprendé el viaje evolutivo que representan y cómo interpretarlos en una lectura.'
}, {
  id: 3,
  title: 'Los 56 Arcanos Menores',
  description: 'Aprendé el significado de los cuatro palos, las figuras de corte y las cartas numeradas. Descubrí cómo interpretar situaciones cotidianas, emociones y procesos personales.'
}, {
  id: 4,
  title: 'Tiradas y Métodos de Lectura',
  description: 'Dominá las tiradas más utilizadas, desde las más simples hasta las más completas. Aprendé a formular preguntas, organizar una consulta y construir interpretaciones claras.'
}, {
  id: 5,
  title: 'Tarot Terapéutico y Evolutivo',
  description: 'Explorá el Tarot como herramienta de autoconocimiento y crecimiento personal. Aprendé a identificar bloqueos, recursos internos y procesos de transformación.'
}, {
  id: 6,
  title: 'Interpretación Profesional del Tarot Rider-Waite',
  description: 'Integrá todo lo aprendido para desarrollar lecturas fluidas, precisas y profesionales. Descubrí técnicas avanzadas para relacionar cartas y construir narrativas coherentes.'
}, {
  id: 7,
  title: 'Fundamentos del Tarot de Marsella',
  description: 'Conocé el origen, la estructura y las características del Tarot de Marsella. Comprendé sus diferencias con Rider-Waite y su enorme riqueza simbólica.'
}, {
  id: 8,
  title: 'Los 22 Arcanos Mayores del Tarot de Marsella',
  description: 'Estudiá el significado de cada Arcano Mayor desde la tradición del Tarot de Marsella, incorporando una mirada simbólica y profunda.'
}, {
  id: 9,
  title: 'Los 56 Arcanos Menores del Tarot de Marsella',
  description: 'Aprendé a interpretar los Arcanos Menores mediante la numerología, la geometría y la simbología propia del Tarot de Marsella.'
}, {
  id: 10,
  title: 'Tiradas y Métodos de Lectura con Tarot de Marsella',
  description: 'Aplicá distintas tiradas utilizando el Tarot de Marsella y desarrollá una metodología clara para responder consultas de forma profesional.'
}, {
  id: 11,
  title: 'Tarot Terapéutico y Simbología del Tarot de Marsella',
  description: 'Profundizá en el lenguaje simbólico del Tarot de Marsella y descubrí cómo utilizarlo como herramienta de reflexión, conciencia y evolución personal.'
}, {
  id: 12,
  title: 'Interpretación Profesional del Tarot de Marsella',
  description: 'Consolidá todos los conocimientos adquiridos y aprendé a realizar interpretaciones completas, integrando símbolos, numerología y contexto para desarrollar lecturas profesionales.'
}];
const samplePages = [{
  src: 'https://cdn.magicpatterns.com/uploads/hDcYxTaLijMaDvwuDHBtNs/ChatGPT_Image_1_jul_2026,_20_40_39.png',
  label: 'Preparación de una Consulta Profesional'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/aDwXGK4P2ZG9harSxvCKJ2/ChatGPT_Image_1_jul_2026,_20_44_02.png',
  label: 'Ases y Doses — Arcanos Menores'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/9yDSAZuWggN7ZVmPTC5VBG/ChatGPT_Image_1_jul_2026,_20_40_18.png',
  label: 'La Cruz Celta'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/n8wDoappoSmP4UuhjFkXpA/ChatGPT_Image_1_jul_2026,_20_45_00.png',
  label: 'Tiradas de 10 Cartas'
}];
export function Curriculum() {
  const [openId, setOpenId] = useState<number | null>(1);
  const [preview, setPreview] = useState<string | null>(null);
  return <section className="py-20 relative z-10" data-id="element-74">
      <div className="container mx-auto px-4" data-id="element-75">
        <motion.div initial={{
        y: 20
      }} whileInView={{
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-4 flex justify-center" data-id="element-76">
          <SectionTitle data-id="element-77">Contenido de la formación</SectionTitle>
        </motion.div>

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-78">
          {tomos.map((tomo, i) => <motion.div key={tomo.id} initial={{
          y: 10
        }} whileInView={{
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.04
        }} className="bg-mystic-800 border border-mystic-700 rounded-xl overflow-hidden" data-id="element-79">
              <button onClick={() => setOpenId(openId === tomo.id ? null : tomo.id)} className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-mystic-700/50 transition-colors" data-id="element-80">
                <div className="flex items-center gap-3 sm:gap-4 min-w-0" data-id="element-81">
                  <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-mystic-900 border border-gold/30 flex items-center justify-center text-gold font-serif flex-shrink-0" data-id="element-82">
                    {tomo.id}
                  </div>
                  <span className="font-medium text-white/90 text-base sm:text-lg" data-id="element-83">
                    {tomo.title}
                  </span>
                </div>
                <ChevronDown className={`text-gold transition-transform duration-300 flex-shrink-0 ml-3 ${openId === tomo.id ? 'rotate-180' : ''}`} data-id="element-84" />
              </button>
              <AnimatePresence data-id="element-85">
                {openId === tomo.id && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} className="overflow-hidden" data-id="element-86">
                    <div className="px-6 pb-5 pt-4 border-t border-mystic-700 mx-6 mt-2" data-id="element-87">
                      <p className="text-white/70 leading-relaxed mb-3" data-id="element-88">
                        {tomo.description}
                      </p>
                      <div className="flex items-center gap-2 text-sm text-gold/70" data-id="element-89">
                        <BookOpen size={16} className="text-gold/60" data-id="element-90" />
                        Módulo completo en formato PDF descargable.
                      </div>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>

        {/* Vistazo al interior del material */}
        <motion.div initial={{
        y: 20
      }} whileInView={{
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-5xl mx-auto mt-20" data-id="element-91">
          <div className="text-center mb-10" data-id="element-92">
            <h3 className="font-serif text-3xl md:text-4xl font-bold text-white mb-3" data-id="element-93">
              Vistazo al interior del material
            </h3>
            <p className="text-white/60 max-w-2xl mx-auto" data-id="element-94">
              Páginas reales de la formación, diseñadas de forma clara,
              profesional y fáciles de estudiar.
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" data-id="element-95">
            {samplePages.map((page, i) => <motion.button key={i} type="button" onClick={() => setPreview(page.src)} initial={{
            y: 20
          }} whileInView={{
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.06
          }} className="group text-left rounded-xl overflow-hidden border border-mystic-700 hover:border-gold/60 bg-mystic-800 transition-colors focus:outline-none focus:ring-2 focus:ring-gold/60" aria-label={`Ver página: ${page.label}`} data-id="element-96">
                <div className="relative overflow-hidden aspect-[3/4]" data-id="element-97">
                  <img src={page.src} alt={page.label} loading="lazy" decoding="async" className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" data-id="element-98" />
                </div>
                <div className="p-3" data-id="element-99">
                  <span className="text-xs sm:text-sm text-white/80 font-medium" data-id="element-100">
                    {page.label}
                  </span>
                </div>
              </motion.button>)}
          </div>
        </motion.div>
      </div>

      {/* Lightbox */}
      <AnimatePresence data-id="element-101">
        {preview && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={() => setPreview(null)} className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4 cursor-zoom-out" role="dialog" aria-modal="true" data-id="element-102">
            <button onClick={() => setPreview(null)} className="absolute top-4 right-4 w-11 h-11 rounded-full bg-mystic-800 border border-gold/40 text-gold flex items-center justify-center hover:bg-mystic-700 transition-colors" aria-label="Cerrar vista previa" data-id="element-103">
              <X size={20} data-id="element-104" />
            </button>
            <motion.img initial={{
          scale: 0.9
        }} animate={{
          scale: 1
        }} exit={{
          scale: 0.9
        }} src={preview} alt="Página de la formación en detalle" onClick={e => e.stopPropagation()} className="max-h-[90vh] max-w-full rounded-lg shadow-2xl object-contain cursor-default" data-id="element-105" />
          </motion.div>}
      </AnimatePresence>
    </section>;
}